import React, { lazy, Suspense, useContext } from "react"
import { IProductOrderDetail } from "interfaces/IProductOrderDetail"
import { IProcessItem } from "interfaces/IItemsOrder"
import { AuthContext } from "context/context/AuthContext"
import useUserPermissions from "hooks/UseUserPermissions"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import ProductDetail from "components/Core/ProductBase/ProductDetail"
import { useGetProductInfoByClient } from "hooks/UseGetMultiClient"
import { clients } from "webapp-clients/Clients"
import { IconCancel, IconSpinner } from "theme/common/Icon.styled"
import { ButtonStyled } from "theme/common/Button.styled"
import ProductOrderDetailStyled, { ProductInfoDetail } from "components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled"

const Img = lazy(() => import("components/Commons/Image/Image"))

interface ProductItemRowProps extends IProductOrderDetail {
  pickingTransition: any; // TODO: Define proper interface
  dispachPickingTransition: any; // TODO: Define proper interface
}

const ProductItemRow = ({
  itemOrder,
  onClicProcessProduct,
  source,
  hideConfirmActions,
  pickingTransition,
  dispachPickingTransition,
  allOrderItems,
}: ProductItemRowProps) => {
  const {
    state: { user },
  } = useContext(AuthContext)

  const fieldProduct = useGetProductInfoByClient(itemOrder)
  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.rejecProduct] })

  const ProductTransition =
    user?.mainGroup?.id && clients[user.mainGroup.id as keyof typeof clients]?.ProductTransition

  const handleClickReject = () => {
    if (itemOrder) {
      onClicProcessProduct({
        ...itemOrder,
        isConfirm: false,
      })
    }
  }

  // Check if this item is already processed
  const isProcessed = pickingTransition?.processItems?.some((pItem: IProcessItem) => pItem.sku === itemOrder?.sku);

  return (
    <ProductOrderDetailStyled>
      <div className="content-info-product">
        <p className="product-name ">{itemOrder?.name}</p>
        <ProductInfoDetail>
          {itemOrder?.custom?.thumbnail && (
            <Suspense fallback={null}>
              <Img alt={itemOrder?.name} url={itemOrder?.custom?.thumbnail} />
            </Suspense>
          )}
          <div className="info">
            <ProductDetail fields={fieldProduct} />
          </div>
        </ProductInfoDetail>

        {/* Only show scanner if not processed */}
        {!isProcessed && ProductTransition && !hideConfirmActions && (
          <Suspense fallback={<IconSpinner variant="big" className="content-center" />}>
            <ProductTransition
              itemOrder={itemOrder}
              onClicProcessProduct={onClicProcessProduct}
              source={source}
              allOrderItems={allOrderItems}
            />
          </Suspense>
        )}

        {/* Show processed status or reject button */}
        {isProcessed ? (
          <ButtonStyled variant="success" disabled>
            <span>Producto Procesado</span>
          </ButtonStyled>
        ) : (
          permission[ResourcePermissionsEnum.rejecProduct] && !hideConfirmActions && (
            <ButtonStyled variant="secondary" onClick={handleClickReject}>
              <IconCancel />
              <span>Rechazar producto</span>
            </ButtonStyled>
          )
        )}
      </div>
    </ProductOrderDetailStyled>
  )
}

export default ProductItemRow
